import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Language } from '../types';
import { setCurrentLanguage } from '../redux/actions/currentLanguage.actions';
import {
  LANGUAGE_ENGLISH,
  LANGUAGE_SPANISH,
  LANGUAGE_PORTUGUESE,
  PREFERRED_LANGUAGE,
} from '../constants';

type UseLanguageReturn = {
  currentLanguage: Language;
  assignLanguage: (language: Language) => void;
};

const useLanguage = (): UseLanguageReturn => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const getCurrentLanguage = (): Language => {
    const lang = i18n.language || LANGUAGE_ENGLISH;

    if (lang.startsWith(LANGUAGE_PORTUGUESE)) return LANGUAGE_PORTUGUESE;
    if (lang.startsWith(LANGUAGE_SPANISH)) return LANGUAGE_SPANISH;
    return LANGUAGE_ENGLISH;
  };

  const assignLanguage = (language: Language): void => {
    try {
      sessionStorage.setItem(PREFERRED_LANGUAGE, language);
    } catch (_e) {
      // storage unavailable; language change still proceeds
    }
    i18n.changeLanguage(language);
    dispatch(setCurrentLanguage(language));
  };

  return {
    currentLanguage: getCurrentLanguage(),
    assignLanguage,
  };
};

export default useLanguage;
